export const INIT = 'initProfession';
export const FETCH_ITEM = 'fetchItem';
export const SET_FOOTER = 'setFooter';
export const SET_PROGRAM = 'setProgram';
export const SET_EMPLOYERS = 'setEmployers';
export const SET_EDUCATION_ORGANIZATIONS = 'setEducationOrganizations';
export const PROGRAM_TITLE = 'Программы';
export const PROGRAM_CARD = 'ItemSingle';
export const FETCH_PROGRAM = 'fetchProgram';
export const FETCH_EMPLOYERS = 'fetchEmployers';
export const FETCH_EDUCATION_ORGANIZATIONS = 'fetchEducationOrganization'
export const STORE_MODULE_NAME = 'profession';
export const SET_PROFESSION = 'setProfession';
export const COMPETTENCE_TITLE = 'Компетенции';
export const EMPLOYERS = 'Работодатели';
export const EDUCATION_ORGANIZATIONS = 'Образовательные организации';
export const SET_COMPETENCES = 'setCompetences';
export const COMPETTENCE_CARD = 'CompetenceCard';
export const ORGANIZATION_SINGLE_ITEM = 'OrganizationSingleItem';
export const SET_NOTHING_FOUND = 'setNothingFound';
export const FETCH_COMPETENCES = 'fetchCompetences';



// WEBPACK FOOTER //
// ./src/pages/professions/card/consts.ts